var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipe-cna-notice"},[_c('img',{staticClass:"cna-img",attrs:{"src":_vm.bgImage,"alt":""}}),_c('div',{staticClass:"cna-btn user-btn",on:{"click":_vm.handelStart}},[_vm._v("我已知晓，谢谢")])])}
var staticRenderFns = []

export { render, staticRenderFns }